export const FETCHING_REDE_APOIO = "redeapoio.buscando_info";
export const FETCHING_REDE_APOIO_COMPLETE = "redeapoio.EDITED_INFO";
export const FETCHING_REDE_APOIO_ERROR = "redeapoio.buscou_info_Error";
export const EDITED_INFO = "redeapoio.editou_info";
